import store from '@/store';
import axios from 'axios';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import moment from 'moment';
import OrderLine from '@/ts/OrderLine';
import Transaction from '@/ts/Transaction';
import Order from '@/ts/Order';

@Module({name: 'UserUpcomingPayments', namespaced: true})
export default class UserUpcomingPayments extends VuexModule {

    public orders: Order[] = [];
    public order: Order = null;
    public stripePublicKey: string = null;

    get getOrder(): Order {
        return this.order;
    }

    get getOrders(): Order[] {
        return this.orders;
    }

    get getStripePublicKey(): string {
        return this.stripePublicKey;
    }

    @Mutation
    public SET_UPCOMING_PAYMENTS_DATA(data: any) {
        this.orders = [];
        for (const order of data) {
            this.orders.push(new Order(
                order.id,
                order.unit_id,
                order.address,
                order.date,
                order.amount,
                order.vat_amount,
                order.total_amount,
                order.project,
                order.unit,
                order.days_overdue,
                order.description,
                order.tenant_type,
                order.payment_date ? order.payment_date : null,
                order.type,
                order.status,
                order.isAutopaid,
            ));
        }
    }

    @Mutation
    public SET_ORDER_DETAILS(order: any) {


        const orderLines = [];
        for (const orderLine of order.orderLines) {
            orderLines.push(new OrderLine(
                orderLine.date,
                orderLine.type,
                orderLine.amount,
                orderLine.vat_amount,
                orderLine.total_amount,
                orderLine.order,
            ));
        }

        this.order = new Order(
                order.id,
                order.unit_id,
                order.address,
                order.date,
                order.amount,
                order.vat_amount,
                order.total_amount,
                order.project,
                order.unit,
                order.days_overdue,
                order.description,
                order.tenant_type,
                order.payment_date ? order.payment_date : null,
                order.type,
                order.status,
                order.isAutopaid,
                order.transactionId,
                order.paymentMethod,
                orderLines,
            );

    }

    @Mutation
    public SET_STRIPE_PUBLIC_KEY(data: any) {
        this.stripePublicKey = data.publicKey;
    }

    @Action
    public FETCH_UPCOMING_PAYMENTS_DATA() {
        axios.get(Endpoints.Finances.FETCH_UPCOMING_PAYMENTS_DATA)
            .then((response) => {
                store.commit(Mutations.SET_UPCOMING_PAYMENTS_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_ORDER_DETAILS(orderId: string) {
        axios.get(Endpoints.Finances.FETCH_ORDER_DETAILS(orderId))
            .then((response) => {
                store.commit(Mutations.SET_ORDER_DETAILS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public PAY_FOR_ORDER(data: any) {
        const requestPayload = {
            orderId: data.orderId,
            paymentMethodId: data.paymentMethodId,
            paymentIntentId: data.paymentIntentId,
        };

        axios.post(Endpoints.Finances.PAY_FOR_ORDER, requestPayload)
            .then((payResponse) => {
                if (payResponse.data.error) {
                   if (payResponse.data.error.type === 'requires_action') {
                       // @ts-ignore
                       const stripe = Stripe(store.getters['UserUpcomingPayments/getStripePublicKey']);

                       stripe.handleCardAction(
                           payResponse.data.paymentIntentClientSecret,
                       ).then((response: any) => {
                           if (response.error) {
                               const errorResponse = new ErrorResponse(response.error.status, response.error.message);
                               store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                               store.dispatch(Actions.USER_TRANSACTION_CANCEL, {transactionId: payResponse.data.transactionId});
                           } else {
                               requestPayload.paymentIntentId = payResponse.data.paymentIntentId;
                               store.dispatch(Actions.PAY_FOR_ORDER, requestPayload);
                           }
                       });
                   } else {
                       const errorResponse = new ErrorResponse(payResponse.data.error.status, payResponse.data.message);
                       store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                   }
            } else {
                store.commit(Mutations.SET_PAY_FOR_ORDER_MODAL_VISIBILITY, false);
                store.commit(Mutations.SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY, true);
                store.commit(Mutations.UPDATE_ORDER_NOTIFICATION, {orderId: requestPayload.orderId, status: 'completed'});
            }

            })
            .catch((error) => {
                store.commit(Mutations.SET_ORDER_PAY_FAILURE_MODAL_VISIBILITY, true);
                if (error && error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public USER_TRANSACTION_CANCEL(data: any) {
        const requestPayload = {
            transactionId: data.transactionId,
        };

        axios.post(Endpoints.Finances.USER_TRANSACTION_CANCEL, requestPayload)
            .then((response) => {
                store.dispatch(Actions.FETCH_ORDER_DETAILS, store.getters['UserUpcomingPayments/getOrder'].id);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_STRIPE_PUBLIC_KEY() {
        axios.get(Endpoints.Finances.FETCH_STRIPE_PUBLIC_KEY)
            .then((response) => {
                store.commit(Mutations.SET_STRIPE_PUBLIC_KEY, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}
